export class VerificationMessages {
  public addDocument = 'verification.add_document';
  public noDocument = 'verification.no_document';

  constructor() {
  }
}
